import React from 'react'
import clsx from 'clsx';
import { ReactComponent as IconBack } from 'images/icons/go-back.svg';
import styles from './BackBtn.module.scss';

type BackBtnProps = {
  className?: string,
  onClick?: () => void,
}

function BackBtn({ className = '', onClick = () => {} }: BackBtnProps) {
  return (
    <button
      type="button"
      className={clsx(styles.btnClose, className)}
      onClick={onClick}
    >
      <IconBack />
    </button>
  )
}

export default BackBtn
